import { ActionType, dashBoardStateType, PAY_STATUS, reducerStoreType } from "./types";

const defaultState = {
  indexStat: {
    tradeAmt: 0,
    tradeNum: 0,
    monthTradeNum: 0,
    monthTradeAmt: 0,
    list: [],
    tradeAmtArea: [],
    latest10List: [],
    countList: [],
    listMap: {},
    tradeAmtAreaMap: {}
  },
  cashier: {
    amt: '',
    remark: '',
    payChannel: '',
    checkcurr: '',
    exchangeRate: 0
  },
  transQr: {
    qrcode: '',
    orderNo: '',
    invalidTime: "",
    modalOpen: false,
    loading: false,
    status: PAY_STATUS.UNPAID
  },
  scanQr: {
    modalOpen: false,
    loading: false
  }
}


const dashboard = (state: dashBoardStateType = defaultState, action: ActionType<any>) => {
  switch (action.type) {
    case 'SET_INDEX_STAT':
      return {
        ...state,
        indexStat: action.payload
      }
    case 'CASHIER_CHANGE':
      return {
        ...state,
        cashier: {
          ...state.cashier,
          ...action.payload
        }
      }
    case 'SET_MERCHANT_INFO':
      let wallet = ''
      if (action.payload.walletList && action.payload.walletList.length > 0 && action.payload.walletList[0].wallet) {
        wallet = action.payload.walletList[0].wallet
      }
      let checkcurr = ''
      let exchangeRate = 0
      if (action.payload.accoutList && action.payload.accoutList.length > 0) {
        checkcurr = action.payload.accoutList[0].currency
        exchangeRate = action.payload.accoutList[0].exchangeRate
      }
      return {
        ...state,
        cashier: {
          ...state.cashier,
          payChannel: wallet,
          checkcurr: checkcurr,
          exchangeRate: exchangeRate
        }
      }
    case 'CREATE_TRANS_QR_SUCC':
      return {
        ...state,
        transQr: {
          ...state.transQr,
          qrcode: action.payload.qrcode,
          orderNo: action.payload.orderNo,
          invalidTime: action.payload.invalidTime
        }
      }
    case 'SCAN_QR_LOADING':
      return {
        ...state,
        scanQr: {
          ...state.scanQr,
          loading: action.payload.status
        }
      }
    case 'SCAN_QR_SUCCESS':
      return {
        ...state,
        scanQr: {
          ...state.scanQr,
          modalOpen: false,
        },
        cashier: {
          amt: '',
          remark: '',
          payChannel: ''
        }
      }
    case 'OPEN_SCAN_QR_MODAL':
      return {
        ...state,
        scanQr: {
          ...state.scanQr,
          modalOpen: true
        }
      }
    case 'CLOSE_SCAN_QR_MODAL':
      return {
        ...state,
        scanQr: {
          ...state.scanQr,
          modalOpen: false
        }
      }
    case 'OPEN_TRANS_QR_MODAL':
      return {
        ...state,
        transQr: {
          ...state.transQr,
          modalOpen: true
        }
      }
    case 'CLOSE_TRANS_QR_MODAL':
      let cashier = state.cashier
      if (state.transQr.status === PAY_STATUS.PAY_SUCCESS) {
        cashier = {
          amt: '',
          remark: '',
          payChannel: '',
          checkcurr: '',
          exchangeRate: 0
        }
      }
      return {
        ...state,
        cashier: cashier,
        transQr: {
          ...state.transQr,
          modalOpen: false,
          qrcode: '',
          orderNo: '',
          invalidTime: "",
          loading: false,
          status: PAY_STATUS.UNPAID
        }
      }
    case 'TRANS_QR_LOADING':
      return {
        ...state,
        transQr: {
          ...state.transQr,
          loading: action.payload.status
        }
      }
    case 'CLEAR_CASHIER':
      return {
        ...state,
        cashier: {
          amt: '',
          remark: '',
          payChannel: ''
        }
      }
    case 'ON_SOCKET_MESSAGE':
      let latest10List = state.indexStat.latest10List
      let newList = latest10List


      let order = action.payload
      order.wallet = order.payChannel
      order.type = 0
      order.buyer = order.buyerEmail
      order.tradeTime = order.payTime

      newList = [order, ...latest10List]



      if (action.payload.orderNo === state.transQr.orderNo) {
        return {
          ...state,
          transQr: {
            ...state.transQr,
            status: PAY_STATUS.PAY_SUCCESS
          },
          indexStat: {
            ...state.indexStat,
            latest10List: newList
          }
        }
      }
      return {
        ...state,
        indexStat: {
          ...state.indexStat,
          latest10List: newList
        }
      }
    default:
      return state;
  }
}
export const getScanQrStatus = (state: reducerStoreType) => (state.dashboard.scanQr.loading)
export const getTransQrStatus = (state: reducerStoreType) => (state.dashboard.transQr.loading)

export default dashboard